import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/service/rest.service';
import { SeoService } from 'src/app/service/seo.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reserch-list',
  templateUrl: './reserch-list.component.html',
  styleUrls: ['./reserch-list.component.css']
})
export class ReserchListComponent implements OnInit {

  researchList: any[] = []   // filtered list shown in the template
  allResearch: any[] = []    // unfiltered master list backing researchList
  keyword = ''               // free-text search (client-side filter)

  constructor(private rest: RestService, private seo: SeoService, private route: Router) { }

  ngOnInit(): void {
    window.scrollTo(0, 0)
    const name = this.rest.getFacultyIDAndName().FACULTY_NAME
    this.seo.update({
      title: `الدراسات والبحوث - ${name}`,
      description: `الدراسات والبحوث العلمية في ${name} بأكاديمية الفنون.`,
      type: 'website'
    })
    this.getData()
  }

  getData() {
    this.rest.getResearch().subscribe((res: any) => {
      this.allResearch = res || []
      this.applyKeyword()
    })
  }

  // The research API ignores text search, so we match the keyword client-side
  // against the loaded items' title and details.
  applyKeyword() {
    const q = this.normalize(this.keyword)
    if (!q) {
      this.researchList = this.allResearch
      return
    }
    this.researchList = this.allResearch.filter(item =>
      this.normalize(item?.TITLE).includes(q) ||
      this.normalize(item?.DETAILS).includes(q)
    )
  }

  // Clears the keyword filter back to the default (show everything).
  clearFilters() {
    this.keyword = ''
    this.applyKeyword()
  }

  // Lowercase + strip Arabic diacritics/spelling variants so the search is
  // forgiving of أ/إ/آ, ى, ة, tatweel and extra spaces.
  private normalize(text): string {
    return String(text || '')
      .toLowerCase()
      .replace(/[ً-ْـ]/g, '')
      .replace(/[أإآ]/g, 'ا')
      .replace(/ى/g, 'ي')
      .replace(/ة/g, 'ه')
      .replace(/\s+/g, ' ')
      .trim()
  }

  Details(item) {
    this.route.navigate(['/research_details', item.ID])
  }

}
